export default [
  {
    text: 'depositRule.table.priority',
    value: 'priority',
  },
  {
    text: 'depositRule.table.deposit',
    value: 'deposit',
    type: 'slot',
  },
  {
    text: 'depositRule.table.startedAt',
    value: 'startedAt',
    type: 'date',
    format: 'DD.MM.YYYY',
  },
  {
    text: 'depositRule.table.endedAt',
    value: 'endedAt',
    type: 'date',
    format: 'DD.MM.YYYY',
  },
];
